import { render, staticRenderFns } from "./layout-landingpage-footer.vue?vue&type=template&id=a0f0da12&scoped=true&"
import script from "./layout-landingpage-footer.vue?vue&type=script&lang=js&"
export * from "./layout-landingpage-footer.vue?vue&type=script&lang=js&"
import style0 from "./layout-landingpage-footer.vue?vue&type=style&index=0&id=a0f0da12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f0da12",
  null
  
)

export default component.exports